<template>
  <div class="box box-shadow profile-parental-consent">
      <template v-if="user.guardian">
        <h3>Parent/Guardian consent</h3>
        <p>The samples associated with this account are for a child or dependant. To provide results we require you to complete the consent form and upload it below.</p>
      </template>
      <template v-else>
          <h3>Parent/Guardian consent</h3>
          <p>Since you are under the age of 18, we need your parent or guardian to consent on your behalf. Once your consent form is complete it must be uploaded below.</p>
      </template>

      <div class="row option">
        <div class="col-md-3">
            <h4>Option 1</h4>
            <p>Email the consent form.</p>
        </div>

        <div class="col-md-9">
            <div v-if="!parentalEmailSuccess" class="form-group input-inline has-feedback has-feedback-left inline-button" :class="{ 'has-danger' : errors.has('email') }">
              <input
                type="email"
                class="form-control form-control-danger"
                v-model="parentEmail"
                name="email"
                v-validate="'required|email'"
                placeholder="Enter an email address">

              <Button
                :disabled="errors.any()"
                @onClick="postParentalConsentEmail"
                v-if="!parentalEmailSuccess"
                text="Send" />
            </div>
            <div class="error text-danger" v-if="parentalEmailError">{{parentalEmailError}}</div>
            <div v-if="parentalEmailSuccess" class="text-success text-right">
                The consent form has been sent to the email provided. Once signed, you will need to upload below in My Profile <i class="icon-check"></i>
            </div>
        </div>
    </div>

    <div class="row option">
        <div class="col-md-6">
            <h4>Option 2</h4>
            <p class="mb-0">Download the form, sign and upload.</p>
            <p class="text-danger">Note: the file size must be less than 1MB.</p>
        </div>
        <div class="col-md-6 my-auto">
          <div class="row">
            <div class="col-12 col-md-6 mb-3">
              <a href="./static/pdf/microba_u18_participant_information_sheet_consent_form.pdf" target="_blank" class="btn btn-outline-primary btn-block">Download</a>
            </div>
            <div class="col-12 col-md-6">
            <FileUploadButton text="Click to upload" @onChange="onChange" :fileSizeLimit="fileSizeLimit" :loading="pending" :success="success" :error="isError" :errorMessage="errorDisplay" />
            </div>
          </div>
        </div>
    </div>

      <div class="row option">
          <div class="col-md-9">
              <h4>Option 3</h4>
              <p v-if="user.guardian"><strong>I will complete this step later.</strong> I acknowledge that I will need to provide a parental or guardian consent form before being able to view my child or dependant's results.</p>
              <p v-else><strong>I will complete this step later.</strong> I acknowledge that I will need parent or guardian consent before being able to view my results.</p>
          </div>
          <div class="col-md-3">
              <div class="row">
                  <div class="col-12">
                      <div class="form-radio pull-right ">
                          <input type="checkbox" v-model="skipConsent" id="inputVal2" value="false">
                          <label for="inputVal2">&nbsp;</label>
                      </div>
                  </div>
              </div>
          </div>
      </div>

    <!-- Disabled for v1
    <div class="row option">
        <div class="col-md-7">
            <h4>Option 2</h4>
            <p>Download the form, sign and upload</p>
        </div>

        <div class="col-md-5" v-if="!success">
          <div class="row">
            <div class="col-6" >
              <a target="_blank" href="#TODO:" class="btn btn-outline-primary btn-block">Download form</a>
            </div>
            <div class="col-6">
              <FileUploadButton class="btn btn-outline-primary btn-block" text="Click to upload" @onChange="onChange" :loading="pending" :success="success" />
              <div class="error" v-if="error">{{errorMessage}}</div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
            <FileUploadButton text="Click to upload" @onChange="onChange" :loading="pending" :success="success" :error="error" :errorMessage="errorMessage" />
            <div class="col-12 col-md-5 success" v-if="success">
                Form successfully uploading and is currently under review <span class="oi oi-check"></span>
            </div>
    </div>
    -->
  </div>
</template>

<script>
import FileUploadButton from '@/components/elements/FileUploadButton'
import Button from '@/components/elements/DynamicButton'
import {microbaSuccess, microbaFailure} from '@/services/notificationServices'

export default {
  name: 'ProfileParentalConsent',
  props: ['parentalConsent', 'localError'],
  components: {
    Button,
    FileUploadButton
  },
  data: function () {
    return {
      file: null,
      parentEmail: '',
      skipConsent: false,
      fileSizeLimit: 1024
    }
  },
  methods: {
    onChange: function (formData) {
      this.$store.dispatch('postParentalConsentForm', formData)
    },
    postParentalConsentEmail: function () {
      this.$store.dispatch('postParentalConsentEmail', this.parentEmail)
    }
  },

  computed: {
    user: function () {
      return this.$store.state.GET_USER_RESPONSE
    },
    pending: function () {
      return this.$store.state.POST_PARENTAL_CONSENT_PENDING
    },
    success: function () {
      if (this.$store.state.POST_PARENTAL_CONSENT_SUCCESS) {
        microbaSuccess({text: `Thank you, your form has been successfully submitted.`})
        return true
      }
      return false
    },
    error: function () {
      return this.$store.state.POST_PARENTAL_CONSENT_FAILURE || false
    },
    errorMessage: function () {
      return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_FAILURE
    },
    parentalEmailPending: function () {
      return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_PENDING
    },
    parentalEmailSuccess: function () {
      return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_SUCCESS
    },
    parentalEmailError: function () {
      return this.$store.state.POST_PARENTAL_CONSENT_EMAIL_FAILURE
    },
    errorDisplay: function () {
      if (this.error) {
        microbaFailure({text: this.error})
        return this.error
      }
      return this.localError
    },
    isError: function () {
      if (this.error) {
        return true
      }
      return this.errorDisplay !== null
    }
  },

  watch: {
    success: function () {
      this.$emit('onSuccess')
    },
    onError: function () {
      this.$emit('onError')
    },
    skipConsent () {
      this.$emit('onSkipConsent')
    }
  }
}
</script>

<style scoped lang="scss">
    .option{
        padding-top: 40px;
        padding-bottom: 20px;
        border-bottom: 1px solid lightblue;
    }
    .error{
      color: red;
      font-size: 12px;
      text-align: right
    }

    .btn-success{
      color: white !important;
      line-height: 30px;
      position: relative;
      padding-right: 60px;
      text-align: right;
      margin-top: 1rem;
      .oi {
        font-size: 30px;
        position: absolute;
        top: 0;
        right: 10px;
      }
    }

    .form-radio{
        margin-top: 24px;
    }

    .inline-button button{
      margin-bottom: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/ProfileParentalConsent.vue